import http from '../../../../libs/http'
export default (id, payload = {
  name: '',
  value: 0,
  state: true
}) => http.put(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/presentation/${id}`, payload)
